import qs from "query-string";

export const exportScreenshotsUrl = (ids: number[]) => {
  if (ids.length === 0) return;

  const query: Record<string, string> = {
    token: localStorage.getItem("token") || "",
    ids: ids.join(","),
  };

  return `${
    process.env.REACT_APP_API_BASE_URL
  }/execution/screenshots/export?${qs.stringify(query)}`;
};
